import React from "react";

export const FaAngleUp = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.16666 4.51171L4.75582 8.92255C4.43082 9.24755 3.90249 9.24755 3.57749 8.92255C3.25249 8.59755 3.25249 8.06921 3.57749 7.74421L9.41082 1.91088C9.73582 1.58505 10.2642 1.58505 10.5892 1.91088L16.4225 7.74421C16.7475 8.06921 16.7475 8.59755 16.4225 8.92255C16.0975 9.24755 15.5692 9.24755 15.2442 8.92255L10.8333 4.51171V17.5C10.8333 17.96 10.46 18.3334 9.99999 18.3334C9.53999 18.3334 9.16666 17.96 9.16666 17.5V4.51171Z" fill="white" />
    </svg>
);
